import { injectable, inject } from 'inversify';
import type { ITenantRepository, TenantGridDTO } from '@/domain/repositories/ITenantRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListTenantsAction {
  constructor(
    @inject(TYPES.ITenantRepository) private tenantRepository: ITenantRepository
  ) {}

  async execute(): Promise<TenantGridDTO[]> {
    return await this.tenantRepository.getAll();
  }
}
